import { render } from "./BlogDetailsArea.vue?vue&type=template&id=6b92a020"
import script from "./BlogDetailsArea.vue?vue&type=script&lang=js"
export * from "./BlogDetailsArea.vue?vue&type=script&lang=js"

import "./BlogDetailsArea.vue?vue&type=style&index=0&id=6b92a020&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__